import React from "react";
import "./Typing.css";
import {useTranslation} from "react-i18next";

export default function Typing() {
    const { t } = useTranslation();

    return (
        <div id="typing">
            <div id="wave">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
            </div>
            <div id="typing-text">
                { t("is_tipping_message") }
            </div>
        </div>
    );
}
